import * as React from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { styled } from "@mui/material";
import { AddAction } from "./AddAction";
import "../../../../../../../../utils/number_extensions";
import { DataTableHeader } from "./DataTableHeader";
import { ISubTransaction } from "./SubTransactionsField";
import { DeleteAction } from "./DeleteAction";
import { EditAction } from "./EditAction";
import moment from "moment";
import { useTransactionFormStore } from "../../../../../../../../hooks/use_transaction_form_store";
import { observer } from "mobx-react";

const StyledTableCell = styled(TableCell)(({theme}) => ({
    textAlign: 'center',
}));

const DescriptionTableCell = styled(TableCell)(({theme}) => ({
    padding: 5,
    textAlign: 'left',
}));

const ActionsTableCell = styled(TableCell)(({theme}) => ({
    width: 60,
    margin: 0,
    padding: 0,
}));

interface IDataTableProps {
    value: ISubTransaction[];
    onChange(value: ISubTransaction[]): void;
}

export const DataTable = observer(({value, onChange}: IDataTableProps) => {
    const { currentTransactionStore } = useTransactionFormStore();

    const [values, setValues] = React.useState<ISubTransaction[]>(value);

    const handleAdd = (value: ISubTransaction) => {
        setValues(oldArray => [...oldArray, value]);
    };

    const handleDelete = (value: number) => () => {
        setValues(oldArray => oldArray.filter((_, index) => index !== value));
    };

    const handleEdit = (index: number) => (value: ISubTransaction) => {
        setValues(oldArray => {
            return oldArray.map((item, i) => {
                if (index === i) {
                    return value;
                } else {
                    return item;
                }
            });
        });
    };

    // React.useEffect(() => {
    //     setValues(value);
    // }, [value]);

    React.useEffect(() => {
        onChange(values);
    }, [values]);

    if (!values.length) {
        return (
            <div>
                <AddAction onChange={handleAdd} />
            </div>
        );
    }

    return (
        <TableContainer>
            <Table size="small">
                    <DataTableHeader onAdd={handleAdd} />
                    <TableBody>
                        {values.map((row, index) => (
                            <TableRow
                                key={index}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <ActionsTableCell>
                                    <EditAction value={row} onChange={handleEdit(index)} />
                                    <DeleteAction onDelete={handleDelete(index)} />
                                </ActionsTableCell>
                                <StyledTableCell>{moment(row.date).format('DD/MM/YYYY')}</StyledTableCell>
                                <StyledTableCell>{(row.amount as any).toCurrency(currentTransactionStore.get('currency'))}</StyledTableCell>
                                <DescriptionTableCell>{row.description}</DescriptionTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
    );
});
